<template>

  <CCard>
    <CCardBody>
      <div class="h1 text-muted text-right mb-3">
        <router-link :to="'/configuracion/parkings/' + parkingCard.id" v-if="!parking.deleted_at">
          <CIcon name="cil-map" height="36" v-c-tooltip.hover.click="'Ver parking'"  />
        </router-link>
         <CIcon v-else name="cil-map" height="36" v-c-tooltip.hover.click="'Ver parking'"  />
      </div>

      <CBadge v-if="parking.deleted_at" 
      v-c-tooltip.hover.click="'Parking eliminado'" style="padding: 0.3rem 0.5rem;" class="mb-2" shape="pill" color="danger">!</CBadge> 

      <div class="mb-2">
        <strong>{{ parkingCard.name }}<span v-if="showPlan"> - {{ planCard.name }}</span></strong>
        <p>{{ parkingCard.address}}</p>
      </div>
      <small class="text-muted text-uppercase font-weight-bold"> Parking </small>
    </CCardBody>
  </CCard>

</template>


<script>

export default {
  name: 'CardParking',
  props: {
    elemento: { type: String, default: 'Plan'},
    title: String,
    loading: Boolean,
    parking: { type: Object, default: function () { return {}}, required: true },
    plan: {
      type: Object,
       default: function () {
        return {}
      },
      required: false
    },
    showPlan: { type: Boolean, default: false}
    // payment: { type: Object, required:true }
  },
  data() {
    return {
    }
  },
  computed:{
    parkingCard: function () {
      return {...this.parking}
    },
    planCard: function () {
      if (this.showPlan) {
        return {...this.plan}
      }

    }
  },
}
</script>
